import { useEffect, useState } from "react";

import { AsyncLoaderControl } from "@/Common/Components/Loader/AsyncLoaderControl";
import { LoginAction } from "@/Common/Stores/Actions/LoginAction";
import { NewExperienceReLoginPage } from "./NewExperienceReLoginPage";
import { ReLogin } from "./ReLogin";

export function ReLoginPageContainer(): JSX.Element {
    const [loadIsReady, setLoadIsReady] = useState<boolean>(false);

    useEffect(() => {
        new LoginAction().loadClinicSettings();

        const onCacheChange = (): void => {
            if (cacheStore.ClinicSettings) {
                setLoadIsReady(true);
            }
        };

        const eventId = cacheStore.AddChangeListener(onCacheChange, this, "LoginPageContainer");

        return () => cacheStore.RemoveChangeListener(eventId);
    }, []);

    const isLoading = !loadIsReady || !cacheStore.ClinicSettings;

    if (isLoading)
        return <AsyncLoaderControl IsActive={isLoading} />;

    return cacheStore.ClinicSettings.EnableLoginPageNewExperience
        ? <NewExperienceReLoginPage />
        : <ReLogin />;
}
